<template>
  <div class="dialog-container wt-dialog-container">
    <div v-loading="isActivityDetailLoading">
      <wt-detail-form-section ref="formSection" :detail-form-data.sync="detailFormData" :detail-form.sync="detailForm" :readonly="true" />
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Activity-view',
  props: ['component-type'],
  isAutoComponent: true,
  data() {
    return {
      formCode: 'MODULES_ACTIVITY',
      isSubmitLoading: false,
      formUpdateUrl: '/modules/activity/activityUpdate',
      formAddUrl: '/modules/activity/activityAdd',
      detailFormButtons: {
        title: '详情',
        elements: [{ name: '创建', key: 'ADD', action: 'ADD', hidden: this.componentType !== 'add' },
          { name: '保存', key: 'EDIT', action: 'EDIT', hidden: this.componentType !== 'edit' },
          { name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      },
      detailForm: {
        title: '基本信息',
        elements: [
          { name: '标题', key: 'title', type: 'text', disabled: true },
          { name: '图片', key: 'coverPathList', type: 'image', disabled: true }]
      }
    }
  },
  created() {
    this.detailFormData.coverPathList = [{ fileUrl: this.detailFormData.coverPath }]
  },
  methods: {
    /*  ------------------------- 按钮  -------------------------  */
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
      }
    },
    /*  ------------------------- 网络请求  -------------------------  */
    onWtDialogClose() {
      this.$emit('on-dialog-action', 'close')
    }
  },
  computed: {
    ...mapState({
      isActivityDetailLoading: state => state.activity.isActivityDetailLoading,
      detailFormData: state => state.activity.activityDetailData
    })
  }
}
</script>

<style scoped>

</style>
